import React from "react"
import { Link } from "gatsby"
import { COLORS } from "../constants/colors"
import moment from "moment"
import { getSpaceDetails } from "../utils/common"
const BookingCardSmall = ({ bookingInfo }) => {
  const {
    spaceName,
    bookingkey,
    spaceaddress,
    startTime,
    status,
    gofloatersSpaceName,
    originalName,
    spaceDisplayName,
    spacePhoto,
  } = bookingInfo
  return (
    <Link to={"/booking-detail?booking_id=" + bookingkey} className="col-md-4">
      <div
        style={{
          padding: 16,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          borderRadius: 8,
          marginHorizontal: 4,
          backgroundColor: COLORS.PRIMARY_BACKGROUND,
          margin: 16,
          boxShadow: "0 3px 8px rgba(0, 0, 0, 0.16)",
        }}
      >
        <img
          src={spacePhoto}
          style={{ width: 96, height: 96, borderRadius: 12 }}
          alt="space photo"
        ></img>
        <div style={{ marginLeft: 8 }}>
          <p style={{ fontSize: "0.7rem" }} className="mb-0 bold">
            {gofloatersSpaceName}
          </p>
          <p
            style={{ fontSize: "0.7rem", color: COLORS.PRIMARY_COLOR }}
            className="mb-0 bold"
          >
            {spaceDisplayName}
          </p>
          <p
            style={{
              fontSize: "0.7rem",
              color: COLORS.STATUS_COLORS.SUCCESS,
            }}
            className="mb-0"
          >
            {status}
          </p>
          <p
            style={{ fontSize: "0.7rem", color: COLORS.TEXT_COLOR_SECONDARY }}
            className="mb-0"
          >
            {getSpaceDetails(spaceaddress)}
          </p>
          <p
            style={{ fontSize: "0.7rem", color: COLORS.PRIMARY_COLOR }}
            className="mb-0"
          >
            {moment(startTime).calendar()}
          </p>
        </div>
      </div>
    </Link>
  )

  // <Pressable style={[styles.container, style]} onPress={onCardClick}>
  //     <Image source={spacePhoto ? { uri: spacePhoto } : IMAGES.ONBOARDING} style={styles.imageStyle} />
  //     <View style={styles.contentStyle}>
  //       <Text variant="bold" size={3}>
  //         {`${showGoFLoatersName ? `${gofloatersSpaceName} - ` : ''}${originalName}`}
  //       </Text>
  //       <Text variant="medium" size={4} color={COLORS.PRIMARY_COLOR}>
  //         {spaceDisplayName}
  //       </Text>
  //       <Text variant="bold" size={4} color={BOOKING_STATUS_LABEL_COLOR[status]}>
  //         {status}
  //       </Text>
  //       <Text variant="medium" size={4} color={COLORS.TEXT_COLOR_SECONDARY}>
  //         {getSpaceDetails(spaceaddress)}
  //       </Text>
  //       <Text variant="bold" size={3} color={COLORS.PRIMARY_COLOR}>
  //         {moment(startTime).calendar()}
  //       </Text>
  //     </View>
  //   </Pressable>
}

export default BookingCardSmall
